import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {

  public ads: any[] = [];
 pages: any = null;          // { key: "delete_acc", value: "true/false" }
  isLoading: boolean = false;
  showConfirm: boolean = false;
    public totalItems = 0;
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private toastr : ToastrService,public _translateService: TranslateService
  ) {} 

 ngOnInit(): void {
    this.getTags();  // Load flag on start
  }

  // Load delete_acc flag
 // Load current flag status
  getTags() {
    this.apisService.flag().subscribe({
      next: (response: any) => {
        this.pages = {
          key: response.key,
          value: String(response.value).toLowerCase()
        };
        console.log("Loaded flag:", this.pages);
      },
      error: () => this.toastr.error("Failed to load status")
    });
  }

  openConfirmModal() {
    this.showConfirm = true;
  }

  closeConfirmModal() {
    this.showConfirm = false;
  }

  // Submit toggle request
   // Toggle value (API toggles automatically)
  submitToggle() {
    this.isLoading = true;

    this.apisService.deleteAccount().subscribe({
      next: () => {
        this.toastr.success("Status updated");

        // Refresh state after toggle
        this.getTags();

        this.isLoading = false;
        this.showConfirm = false;
      },
      error: () => {
        this.toastr.error("Error updating status");
        this.isLoading = false;
      }
    });
  }
}